// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Modal$DvmAdminFrontendFr from "../../common/components/App_Modal.bs.js";
import * as App_Table$DvmAdminFrontendFr from "../../common/components/table/App_Table.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../context/user/User_Context.bs.js";
import * as App_Table_Head$DvmAdminFrontendFr from "../../common/components/table/App_Table_Head.bs.js";
import * as App_Table_Types$DvmAdminFrontendFr from "../../common/components/table/App_Table_Types.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../intl/messages/Messages_Common.bs.js";
import * as App_Table_Simple$DvmAdminFrontendFr from "../../common/components/table/App_Table_Simple.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../common/types/App_Types_Result.bs.js";
import * as Pool_Expenses_Api$DvmAdminFrontendFr from "./Pool_Expenses_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";

var headersConfiguration_0 = App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("year", undefined, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.year);

var headersConfiguration_1 = {
  hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("period", undefined, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.period),
  tl: {
    hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("availableExpenses", undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.availableExpenses),
    tl: /* [] */0
  }
};

var headersConfiguration = {
  hd: headersConfiguration_0,
  tl: headersConfiguration_1
};

function Pool_Expenses_Available_Expenses_Modal(Props) {
  var onClose = Props.onClose;
  var level = Props.level;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$2[1];
  var result = match$2[0];
  React.useEffect((function () {
          Pool_Expenses_Api$DvmAdminFrontendFr.fetchAllRows(userManager, setResult, selectedRole, level);
        }), []);
  var convertTable = function (param) {
    return App_Types_Result$DvmAdminFrontendFr.map(result, (function (periods) {
                  return Belt_List.map(periods, (function (item) {
                                return App_Table_Types$DvmAdminFrontendFr.makeRow(undefined, undefined, undefined, Belt_List.mapWithIndex({
                                                hd: item.year,
                                                tl: {
                                                  hd: item.periodID,
                                                  tl: {
                                                    hd: level ? Belt_Option.mapWithDefault(item.remainingResources, "", (function (prim) {
                                                              return String(prim);
                                                            })) : Belt_Option.mapWithDefault(item.resourcesToAllocate, "", (function (prim) {
                                                              return String(prim);
                                                            })),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }, (function (index, content) {
                                                  return App_Table$DvmAdminFrontendFr.makeCell(Belt_Option.map(Belt_List.get(headersConfiguration, index), (function (param) {
                                                                    return param.align;
                                                                  })), undefined, undefined, content);
                                                })));
                              }));
                }));
  };
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.availableExpenses),
              minWidth: "500px",
              children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                    show: App_Types_Result$DvmAdminFrontendFr.isPending(result),
                    children: React.createElement(App_Table_Simple$DvmAdminFrontendFr.make, {
                          headers: headersConfiguration,
                          content: convertTable(undefined),
                          width: "100%",
                          height: "55vh"
                        })
                  })
            });
}

var make = Pool_Expenses_Available_Expenses_Modal;

export {
  headersConfiguration ,
  make ,
}
/* headersConfiguration Not a pure module */
